
export const TEST_API_BASE_URL = 'https://api.test.ahalab.io/';
export const PRE_API_BASE_URL = 'https://api.pre.ahalab.io/';
export const BASE_URL = 'https://api.ahalab.io/';

// Define a type alias for environment names
type Environment = 'production' | 'pre' | 'staging' | 'development';

interface Config {
  BASE_URL: string;
  applicationId: string;
  clientToken: string;
  env: Environment;
  clerkPublishableKey: string;
  stripe_public_key: string;
  timBaseUrl: string;
}

// staging 为测试环境。

const stripe_public_key = "pk_test_51QFSPwCmpvoJKd3Q3N1NrBOCAYjc6tSPmaCyUYSaEEHynd01MtyKAdmVIsUiHC6dMm7bbSOQxNKDW9Rst9jjWgIH00U0vugJVy"
const stripe_product_public_key = "pk_live_51QFSPwCmpvoJKd3QLWua58AL4cbffFGHhYlEdibmqACzTrgbac6PXgrfGgiGp389kNBs8QUXNoDkX7gmifFX67VZ00XofQo9TS";


const environmentConfig: Record<Environment, Config> = {
  production: {
    BASE_URL: BASE_URL,
    // 观测云 prod 工作空间
    // advertiser-platform
    applicationId: 'a83c6d50_5003_11ef_98f7_abcd5678efgh',
    clientToken: '7de3f51e6aab4bbdb38b2dfd35073a56',
    env: 'production',
    clerkPublishableKey: 'pk_live_Y2xlcmsuYWhhY3JlYXRvci5jb20k',
    stripe_public_key: stripe_product_public_key,
    timBaseUrl: 'https://im-ui.ahacreator.com',
  },
  pre: {
    BASE_URL: PRE_API_BASE_URL,
    // 观测云 pre 工作空间
    applicationId: '',
    clientToken: '',
    env: 'pre',
    clerkPublishableKey: 'pk_test_c291Z2h0LWdlbGRpbmctNDMuY2xlcmsuYWNjb3VudHMuZGV2JA',
    stripe_public_key: stripe_product_public_key,
    timBaseUrl: 'https://im-ui.ahacreator.com',
  },
  staging: {
    BASE_URL: TEST_API_BASE_URL,
    // 观测云 test 工作空间，后会改名为 staging
    // advertiser-platform
    applicationId: '979ebd10_b5dc_11ef_8a49_6924ceb4c413',
    clientToken: 'dba74988e50b4aad8bcca68dc6123897',
    env: 'staging',
    clerkPublishableKey: 'pk_test_c291Z2h0LWdlbGRpbmctNDMuY2xlcmsuYWNjb3VudHMuZGV2JA',
    stripe_public_key,
    timBaseUrl: 'https://test.im-ui.ahacreator.com',
  },
  development: {
    BASE_URL: TEST_API_BASE_URL,
    // 观测云 test 工作空间，后会改名为 staging
    // advertiser-platform
    applicationId: '979ebd10_b5dc_11ef_8a49_6924ceb4c413',
    clientToken: 'dba74988e50b4aad8bcca68dc6123897',
    env: 'staging',
    clerkPublishableKey: 'pk_test_c291Z2h0LWdlbGRpbmctNDMuY2xlcmsuYWNjb3VudHMuZGV2JA',
    stripe_public_key,
    timBaseUrl: 'http://localhost:5173',
  }
};

const env = (process.env.REACT_APP_ENV as Environment) || 'staging';
console.log('env', env);

const appConfig = environmentConfig[env];

export default appConfig;

export const MIN_BUDGET_LIMIT = 2000;